<template>
  <div>
    <div class="AboutUs">
      <PageBanner>
        <template slot="title">Terms &amp; Conditions</template>
      </PageBanner>
      <div class="container-fluid tarms-conditions">
        <div class="row">
          <div class="container">
            <h3>Terms and Conditions</h3>
            <p>
              1
              <strong>About our Terms</strong>
            </p>
            <p>
              1.1 These terms (the
              <strong>&ldquo;Terms&rdquo;</strong>) explain
              how you may use this website, accessible via the following url:
              <a href="http://www.manfluence.co/">experientialstar.com</a>
              (the
              <strong>&ldquo;Site&rdquo;</strong>) which is provided by us
              free of charge.
            </p>
            <p>
              1.2 In these Terms,
              <strong>&ldquo;We&rdquo;</strong>,
              <strong>&ldquo;we&rdquo;</strong>,
              <strong>&ldquo;us&rdquo;</strong>,
              <strong>&ldquo;our&rdquo;</strong> or
              <strong>&ldquo;Experiential Star&rdquo;</strong> (as applicable)
              refers to Life of Riley Media FZ-LLC, Ground floor Building
              16, Dubai Internet City, Dubai, UAE.
            </p>
            <p>1.3 You should read these Terms carefully before using the Site.</p>
            <p>
              1.4 By accessing or using the Site or otherwise indicating your
              consent, you agree to be bound by these Terms and the documents
              referred to in them.
            </p>
            <p>
              1.5 If you do not agree with or accept any of these Terms, you
              should stop using the Site immediately.
            </p>
            <p>
              1.6 If you have any questions about the Site, please contact us
              by:
            </p>
            <p>
              e-mail via
              <strong>info@experientialstar.com</strong>
            </p>
            <p>1.7 Additional Definitions</p>
            <div class="table-responsive">
              <table>
                <tbody>
                  <tr>
                    <td>
                      <p>
                        <strong>[1] &ldquo;Cookie policy&rdquo;</strong>
                      </p>
                    </td>
                    <td>
                      <p>
                        means the policy [insert link to your cookie policy][2]
                        , which governs how we use cookies via the Site;
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>
                        <strong>&ldquo;Content&rdquo;</strong>
                      </p>
                    </td>
                    <td>
                      <p>
                        means (each and collectively, as applicable) any text,
                        images, video, audio or other multimedia content,
                        software or other information or material submitted to
                        or on the Site;
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>
                        <strong>&ldquo;Copyright policy&rdquo;</strong>
                      </p>
                    </td>
                    <td>
                      <p>
                        means the policy [insert link to your Copyright policy],
                        [3] which governs how we deal with claims of copyright
                        infringement, for End Users that access the Site from
                        within the United States, and applies to you if you are
                        located in the United States;
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>
                        <strong>&ldquo;End User&rdquo;</strong>
                      </p>
                    </td>
                    <td>
                      <p>
                        means any user of the Site, that uses the Site to view
                        one or more Events on the Site and/or (as applicable)
                        accesses a Landing Page;[4]
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>
                        <strong>&ldquo;Event&rdquo;</strong>
                      </p>
                    </td>
                    <td>
                      <p>
                        means each event that is listed on the following page of
                        the Site: experientialstar.com, that any End User can
                        click on to be directed to its Landing Page;
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>
                        [5]
                        <strong>&ldquo;Landing Page&rdquo;</strong>
                      </p>
                    </td>
                    <td>
                      <p>
                        means with respect to an Event, the website associated
                        with that Event, it being understood that any End User
                        can access the Landing Page by clicking on the
                        applicable Event on the Site;
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>
                        [6] [JO7]
                        <strong>&ldquo;Landing Page Content&rdquo;</strong>
                      </p>
                    </td>
                    <td>
                      <p>
                        means (each and collectively, as applicable) any part of
                        the Content that is content derived or linked directly
                        from your Landing Page;
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>
                        <strong>[8] &ldquo;Link&rdquo;</strong>
                      </p>
                    </td>
                    <td>
                      <p>
                        means a hyperlink, in whatever form, which can be
                        clicked on by an End User to direct that End User to the
                        applicable Landing Page.
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>
                        <strong>[9] &ldquo;Privacy policy&rdquo;</strong>
                      </p>
                    </td>
                    <td>
                      <p>
                        means the policy [insert link to your privacy policy],
                        [JO7] which governs how we process any personal data
                        collected from you;
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>
                        <strong>[10] &ldquo;Services&rdquo;</strong>
                      </p>
                    </td>
                    <td>
                      <p>
                        means collectively all the services accessible on the
                        Site;
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>
                        <strong>[11] &ldquo;Site&rdquo;</strong>
                      </p>
                    </td>
                    <td>
                      <p>has the meaning given to it in clause 1.1;</p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p>
              1.7 Your use of the Site means that you must also comply with our
              Acceptable use policy, our Privacy policy, our Copyright policy,
              and our Cookie policy.
            </p>
            <p>2 Using the Site[JO12]</p>
            <p>
              2.1 You are entitled to browse the Site for Events you are
              interested in and click on any Event you want to enquire more
              about (each a
              <strong>&ldquo;click&rdquo;</strong>). Every time
              you are logged in as an End User of the Site and you click on an
              Event, you could receive an internal message on the Site from the
              applicable Event organiser. The message will be forwarded to the
              email address you provide during the registration process to
              becoming an End User. There is certain functionality on the Site
              that enables you to set the frequency of such messages to
              &lsquo;instantly&rsquo;, &lsquo;daily&rsquo; or
              &lsquo;weekly&rsquo;.
            </p>
            <p>
              2.2 It is Experiential Star&rsquo;s company policy not to market
              any Experiential Star products or services to persons under
              eighteen (18) years of age. Experiential Star does not knowingly
              gather or solicit data from persons under eighteen (18) years of
              age through this Site for marketing purposes. You herewith warrant
              that you are not under eighteen (18) years of age.
            </p>
            <p>2.3 You agree that you are solely responsible for:</p>
            <ol>
              <li>
                a) all costs and expenses you may incur in relation to your use
                of the Site; and
              </li>
              <li>b) keeping your password and other account details confidential.</li>
            </ol>
            <p>
              2.4 We seek to make the Site as accessible as possible. If you
              have any difficulties using the Site, please contact us at
              info@experientialstar.com
            </p>
            <p>
              2.5 We may prevent or suspend your access to the Site if you do
              not comply with any part of these Terms, any terms or policies to
              which they refer or any applicable law.
            </p>
            <p>3 Ownership, use and intellectual property rights</p>
            <p>
              3.1 This Site and all intellectual property rights in it including
              but not limited to any Content are owned by us, our licensors
              (including without limitation, for the avoidance of doubt, the
              Landing Page Content licensed to us by you as detailed in the
              remaining provisions of these Terms) or both (as applicable).
              <strong>&ldquo;Intellectual Property Rights&rdquo;</strong> means
              rights such as: copyright, trademarks, domain names, design
              rights, database rights, patents and all other intellectual
              property rights of any kind whether or not they are registered or
              unregistered (anywhere in the world). We and our licensors reserve
              all of our and their rights in any intellectual property in
              connection with these Terms. This means, for example, that we and
              they remain owners of them and free to use them as we and they see
              fit.
            </p>
            <p>
              3.2 Nothing in these Terms grants you any legal rights in the Site
              other than as necessary to enable you to access the Site. You
              agree not to adjust to try to circumvent or delete any notices
              contained on the Site (including any intellectual property
              notices) and in particular in any digital rights or other security
              technology embedded or contained within the Site.
            </p>
            <p>
              3.3 The use of any trademarks on the Site is strictly prohibited
              unless you have our prior written permission.
            </p>
            <p>4 Accuracy of information and availability of the Site</p>
            <p>
              4.1 While we try to make sure that the Site is accurate,
              up-to-date and free from bugs, we cannot promise that it will be.
              Furthermore, we cannot promise that the Site will be fit or
              suitable for any purpose. Any reliance that you may place on the
              information on this Site is at your own risk.
            </p>
            <p>
              4.2 We may suspend or terminate operation of the Site at any time
              as we see fit.
            </p>
            <p>
              4.3 Content (except Landing Page Content, which is provided by
              you, for the avoidance of doubt) is provided for your general
              information purposes only and to inform you about us and our
              products and news, features, services and other websites that may
              be of interest. It does not constitute technical, financial or
              legal advice or any other type of advice and should not be relied
              on for any purposes.
            </p>
            <p>
              4.4 While we try to make sure that the Site is available for your
              use, we do not promise that the Site is available at all times nor
              do we promise the uninterrupted use by you of the Site.
            </p>
            <p>5 Hyperlinks and third party sites</p>
            <p>
              The Site contains Links and may contain other hyperlinks or
              references to third party websites other than the Site. Any such
              hyperlinks or references are provided for your convenience only.
              We have no control over third party websites and accept no legal
              responsibility for any Content, other content (where applicable),
              material or information contained in them. The display of any
              hyperlink and reference to any third party website does not mean
              that we endorse that third party's website, products or services.
              Your use of a third party site may be governed by the terms and
              conditions of that third party site.
            </p>
            <p>6 Limitation on our liability</p>
            <p>
              6.1 For the avoidance of doubt, we have no control over any of the
              Events on the Site, and therefore Experiential Star shall not bear
              any responsibility, legal or otherwise for any of the Events and
              any losses or damages suffered by an End User that takes part in
              any Event. In addition to the foregoing, except for any legal
              responsibility that we cannot exclude in law (such as for death or
              personal injury), we are not legally responsible for any:
            </p>
            <ol>
              <li>a) losses that:</li>
            </ol>
            <p>(a) are indirect or consequential,</p>
            <p>(b) are losses of profit or earnings;</p>
            <p>
              (c) were not foreseeable to you and us when these Terms were
              formed; or
            </p>
            <p>
              (d) that were not caused by any negligent or wilful breach on our
              part;
            </p>
            <ol>
              <li>b) business losses; and</li>
              <li>c) losses to non-consumers.</li>
            </ol>
            <p>7 Events beyond our control</p>
            <p>
              We shall have no liability to you for any breach of these Terms
              caused by any event or circumstance beyond our reasonable control
              including, but not limited to, strikes, lock-outs or other
              industrial disputes; breakdown of systems or network access; or
              flood, fire, explosion or accident.
            </p>
            <p>8 Rights of third parties</p>
            <p>
              No one other than a party to these Terms has any right to enforce
              any of these Terms.
            </p>
            <p>9 Variation</p>
            <p>
              These Terms are dated [insert date on which the Terms were last
              updated Tuesday March 5th 2019. No changes to these Terms are
              valid or have any effect unless agreed by us in writing. We
              reserve the right to vary these Terms from time to time. Our
              updated terms will be displayed on the Site and by continuing to
              use and access the Site following such changes, you agree to be
              bound by any variation made by us. It is your responsibility to
              check these Terms from time to time to verify such variations.
            </p>
            <p>10 Disputes, Governing Law and Jurisdiction</p>
            <p>
              10.1 We will try to resolve any disputes with you quickly and
              efficiently.
            </p>
            <p>
              10.2 If you are unhappy with us please contact us as soon as
              possible.
            </p>
            <p>
              10.3 If you and we cannot resolve a dispute using our complaint
              handling procedure, we will:
            </p>
            <ol>
              <li>a) let you know that we cannot settle the dispute with you; and</li>
              <li>
                b) give you certain information about our alternative dispute
                resolution provider.
              </li>
            </ol>
            <p>
              10.4 These Terms, their subject matter and their formation, are
              governed by English law. You and we both agree that the courts of
              England and Wales will have exclusive jurisdiction.
            </p>
            <ol start="11">
              <li>
                <strong>Severability</strong>
              </li>
            </ol>
            <p>
              All clauses, sub-clauses and parts thereof shall be severable and
              shall be read and construed independently. Should any part of
              these Terms be found invalid this will not affect the validity or
              enforceability of any other provision or of this Agreement as a
              whole.
            </p>
            <ol start="12">
              <li>
                <strong>Assignment</strong>
              </li>
            </ol>
            <p>
              12.1 We may transfer our rights and obligations under these Terms
              to a third party, whether as part of a sale of all or part of our
              assets or for any other reason.We will try to give you reasonable
              notice of such transfer and we will make sure that such transfer
              will not prejudice your rights and obligations under these Terms.
            </p>
            <p>
              12.2 You may not transfer your rights and obligations under these
              Terms under any circumstances without our prior consent. Any such
              transfer shall be deemed null and void.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageBanner from '@/components/PageBanner.vue'
import metaInfoMixin from '../mixins/metaInfo'

export default {
  mixins: [metaInfoMixin],
  components: {
    PageBanner
  },
  created() {
    this.setMetaInfo({
      title: 'Terms & Conditions',
      desc: '',
      keywords: '',
      img: '',
      url: window.location.href
    })
  }
}
</script>

<style lang="scss" scoped></style>
